/* global WEB_ROOT */

import {
  formatDateLong,
  formatDateTime,
  formatPrice,
} from '../../utils/formats';

import authService from '../services/auth';

/**
 * Race detail resolver.
 * This pure function annotates race detail objects with computed values, e.g. formatted strings.
 */
const resolver = race => race && {
  ...race,
  ...(race.eventDetails && {
    // Race page no longer exists, use event page
    canonical: `${WEB_ROOT}/e/${race.eventDetails.slug}-${race.eventDetails.id}`,
    eventDetails: {
      ...race.eventDetails,
      // Construct event site link for router
      permalink: `/e/${race.eventDetails.slug}-${race.eventDetails.id}`,
    },
  }),
  // Start date is optional
  ...(race.startDate && {
    startDateFormatted: formatDateLong(race.startDate),
  }),
  ...(race.startTime && {
    startTimeFormatted: formatDateTime(race.startDate),
  }),
  // Tickets are optional
  ...(race.tickets && {
    tickets: {
      ...race.tickets,
      // Format from price
      pricesFromFormatted: formatPrice(race.tickets.currencyLabel, race.tickets.pricesFrom),
      // Format to price, optional (number)
      ...(typeof race.tickets.pricesTo !== 'undefined' && {
        pricesToFormatted: formatPrice(race.tickets.currencyLabel, race.tickets.pricesTo),
      }),
      // Tickets are optional
      ...(race.tickets.tickets && {
        tickets: race.tickets.tickets.map(ticket => ({
          ...ticket,
          // Availability is optional
          ...(ticket.availability && {
            availability: {
              ...ticket.availability,
              // Format from date, optional
              ...(ticket.availability.from && {
                fromFormatted: formatDateLong(ticket.availability.from),
              }),
              // Format from date, optional
              ...(ticket.availability.to && {
                toFormatted: formatDateLong(ticket.availability.to),
              }),
            },
          }),
          bookingUrl: (ticket.bookingUrl.replace(/__USER_ID__/g, authService.getUserCookie() || 'LO')),
          rrpFormatted: formatPrice(race.tickets.currencyLabel, ticket.rrp),
          // Format discount price, optional (number)
          ...(typeof ticket.discountPrice !== 'undefined' && {
            discountPriceFormatted: formatPrice(race.tickets.currencyLabel, ticket.discountPrice),
          }),
        })),
      }),
    },
  }),
};

export default resolver;



// WEBPACK FOOTER //
// ./app/src/state/resolvers/race.js